import { gql } from '@apollo/client';
import { PartnerUserInfoShared } from '../fragments';

export default gql`
  mutation discardPartnerUser($input: PartnerUserDiscardInput!) {
    discardPartnerUser(input: $input) {
      clientMutationId
      partnerUser {
        ...PartnerUserInfoShared
      }
    }
  }
  ${PartnerUserInfoShared}
`;
